export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-03.ed5a82d6.jpg";